module.exports = __webpack_public_path__ + "img/nor_sm_moun1.d709a733.png";